(function () {
  'use strict';

  if (window.__rrAhrefsCoreInitialized) return;
  window.__rrAhrefsCoreInitialized = true;

  var config = window.RRKlaviyoConfig || {};
  var page = config.page || {};
  var queue = [];
  var dedupeMemory = Object.create(null);
  var queueLimit = 100;
  var flushTimer = null;
  var recommendationImpressed = new WeakSet();

  function getCustomerPrivacyApi() {
    if (typeof Shopify === 'undefined' || !Shopify.customerPrivacy) return null;
    return Shopify.customerPrivacy;
  }

  function analyticsAllowed() {
    try {
      var privacy = getCustomerPrivacyApi();
      if (!privacy) return true;
      if (typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed();
      }
      if (typeof privacy.userCanBeTracked === 'function') {
        return privacy.userCanBeTracked();
      }
      return true;
    } catch (error) {
      return true;
    }
  }

  function hasRuntime() {
    return !!(window.AhrefsAnalytics && typeof window.AhrefsAnalytics.sendEvent === 'function');
  }

  function toNumber(value) {
    if (value === null || value === undefined || value === '') return null;
    var normalized = typeof value === 'string' ? value.replace(/,/g, '').trim() : value;
    var numeric = Number(normalized);
    return Number.isFinite(numeric) ? numeric : null;
  }

  function toStringValue(value) {
    if (value === null || value === undefined || value === '') return null;
    if (Array.isArray(value)) {
      var flattened = value
        .map(function (item) {
          if (item === null || item === undefined || item === '') return null;
          return String(item).trim();
        })
        .filter(Boolean);
      return flattened.length ? flattened.join('|') : null;
    }
    if (typeof value === 'boolean') return value ? 'true' : 'false';
    if (typeof value === 'number') return Number.isFinite(value) ? String(value) : null;
    if (typeof value === 'string') {
      var trimmed = value.trim();
      return trimmed ? trimmed : null;
    }
    return null;
  }

  function normalizeKey(key) {
    return String(key || '')
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      .replace(/[^a-zA-Z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .toLowerCase();
  }

  function normalizeEventName(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function isDisallowedKey(key) {
    return /(email|phone|name|address|customer|first_name|last_name)/.test(key);
  }

  function sanitizeProps(input) {
    var source = input || {};
    var props = {};
    var keys = Object.keys(source);

    for (var i = 0; i < keys.length; i += 1) {
      var normalizedKey = normalizeKey(keys[i]);
      if (!normalizedKey || isDisallowedKey(normalizedKey)) continue;
      var normalizedValue = toStringValue(source[keys[i]]);
      if (normalizedValue === null) continue;
      props[normalizedKey] = normalizedValue;
    }

    return props;
  }

  function inferSurfaceFromSource(source) {
    switch (String(source || '')) {
      case 'product-form':
      case 'variant-change':
        return 'pdp';
      case 'quick-add':
        return 'collection';
      case 'quick-order-list':
        return 'quick_order_list';
      case 'pdp-upsell-add':
        return 'pdp_upsell';
      case 'cart-page':
      case 'checkout-click':
      case 'checkout-submit':
      case 'checkout-trigger':
      case 'cart-items':
      case 'cart-addon':
        return 'cart';
      case 'theme-form':
        return 'newsletter';
      case 'page-load':
        return page.type || 'storefront';
      default:
        return page.type || 'storefront';
    }
  }

  function baseProps(extra) {
    return Object.assign(
      {
        page_type: page.type || null,
        currency: config.currency || null,
      },
      extra || {}
    );
  }

  function shouldSkipByDedupe(key, ttlMs) {
    if (!key) return false;
    var now = Date.now();
    var ttl = typeof ttlMs === 'number' ? ttlMs : 30000;

    try {
      var storageKey = '__rr_ahrefs_' + key;
      var previous = Number(window.sessionStorage.getItem(storageKey) || '0');
      if (previous && now - previous < ttl) return true;
      window.sessionStorage.setItem(storageKey, String(now));
      return false;
    } catch (error) {
      var memo = dedupeMemory[key] || 0;
      if (memo && now - memo < ttl) return true;
      dedupeMemory[key] = now;
      return false;
    }
  }

  function enqueue(name, props) {
    if (queue.length >= queueLimit) queue.shift();
    queue.push({ name: name, props: props });
  }

  function sendNow(name, props) {
    try {
      window.AhrefsAnalytics.sendEvent(name, { props: props });
      return true;
    } catch (error) {
      return false;
    }
  }

  function flushQueue() {
    if (!analyticsAllowed() || !hasRuntime() || !queue.length) return;

    while (queue.length) {
      var entry = queue.shift();
      if (!entry || !entry.name) continue;
      if (!sendNow(entry.name, entry.props || {})) {
        enqueue(entry.name, entry.props || {});
        break;
      }
    }
  }

  function scheduleFlush(delayMs) {
    if (flushTimer) return;
    flushTimer = window.setTimeout(function () {
      flushTimer = null;
      flushQueue();
    }, typeof delayMs === 'number' ? delayMs : 300);
  }

  function track(eventName, props, options) {
    var normalizedEventName = normalizeEventName(eventName);
    if (!normalizedEventName) return false;

    var opts = options || {};
    if (opts.dedupeKey && shouldSkipByDedupe(opts.dedupeKey, opts.ttlMs)) return false;
    if (!analyticsAllowed()) return false;

    var finalProps = sanitizeProps(baseProps(props));

    if (hasRuntime()) {
      return sendNow(normalizedEventName, finalProps);
    }

    enqueue(normalizedEventName, finalProps);
    scheduleFlush();
    return true;
  }

  function mapSourceProps(payload) {
    return {
      source: payload.Source || null,
      surface: inferSurfaceFromSource(payload.Source),
    };
  }

  function trackMappedKlaviyoEvent(eventName, payload, dedupeKey, ttlMs) {
    var input = payload && typeof payload === 'object' ? payload : {};
    var commonProps = Object.assign(
      {
        product_id: input.ProductID || null,
        variant_id: input.VariantID || null,
        sku: input.SKU || null,
        product_title: input.Name || null,
        vendor: input.Brand || null,
        product_type: input.Category || null,
        price: input.Price,
        compare_at_price: input.CompareAtPrice,
        quantity: input.Quantity,
        cart_value: input.$value,
        item_count: input.ItemCount,
        collection_id: input.CollectionID || null,
        collection_handle: input.Handle || null,
        search_term: input.SearchTerm || null,
        results_count: input.ReturnedResults,
      },
      mapSourceProps(input)
    );

    switch (eventName) {
      case 'Viewed Product':
        return track('view_product', commonProps, { dedupeKey: dedupeKey, ttlMs: ttlMs });
      case 'Viewed Collection':
        return track('view_collection', commonProps, { dedupeKey: dedupeKey, ttlMs: ttlMs });
      case 'Searched Site':
        return track('search', commonProps, { dedupeKey: dedupeKey, ttlMs: ttlMs });
      case 'Viewed Cart':
        return track('view_cart', commonProps, { dedupeKey: dedupeKey, ttlMs: ttlMs });
      case 'Added to Cart':
        return track('add_to_cart', commonProps, { dedupeKey: dedupeKey, ttlMs: ttlMs });
      case 'Started Checkout':
        return track('begin_checkout', commonProps, { dedupeKey: dedupeKey, ttlMs: ttlMs });
      case 'Newsletter Signup Submitted':
        return track(
          'newsletter_signup_submitted',
          {
            source: input.Source || 'theme_form',
            surface: 'newsletter',
          },
          { dedupeKey: dedupeKey, ttlMs: ttlMs }
        );
      default:
        return false;
    }
  }

  function resolveProductHandleFromHref(href) {
    if (!href) return null;
    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    } catch (error) {
      return null;
    }
  }

  function getCurrentProductContext() {
    return page.product || null;
  }

  function bindVariantTracking() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      var data = payload && payload.data ? payload.data : {};
      var variant = data.variant || {};
      var product = getCurrentProductContext();
      var variantId = variant.id || (product && product.variant && product.variant.id) || null;
      if (!variantId) return;

      track(
        'select_variant',
        {
          surface: 'pdp',
          source: 'variant_change',
          product_id: product && product.id ? String(product.id) : null,
          variant_id: String(variantId),
          sku: variant.sku || null,
          product_title: product && product.title ? product.title : null,
          vendor: product && product.vendor ? product.vendor : null,
          product_type: product && product.type ? product.type : null,
          price: variant.price,
          compare_at_price: variant.compare_at_price,
        },
        {
          dedupeKey: 'select_variant:' + String(variantId),
          ttlMs: 1000,
        }
      );
    });
  }

  function bindCartMutationTracking() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      var source = payload && payload.source ? payload.source : '';
      var mutation = payload && payload.mutation ? payload.mutation : '';
      var cart = payload && payload.cartData && typeof payload.cartData === 'object' ? payload.cartData : {};

      if (source === 'cart-items' && mutation === 'remove') {
        track(
          'remove_from_cart',
          {
            surface: 'cart',
            source: source,
            variant_id: payload.variantId || null,
            quantity: payload.previousQuantity || null,
            item_count: cart.item_count,
            cart_value: cart.total_price ? Number(cart.total_price) / 100 : null,
          },
          {
            dedupeKey: 'remove_from_cart:' + String(payload.variantId || '') + ':' + String(payload.previousQuantity || ''),
            ttlMs: 2000,
          }
        );
      }

      if (source === 'cart-items' && mutation === 'change') {
        track(
          'update_cart_quantity',
          {
            surface: 'cart',
            source: source,
            variant_id: payload.variantId || null,
            quantity: payload.quantity || null,
            previous_quantity: payload.previousQuantity || null,
            item_count: cart.item_count,
            cart_value: cart.total_price ? Number(cart.total_price) / 100 : null,
          },
          {
            dedupeKey:
              'update_cart_quantity:' +
              String(payload.variantId || '') +
              ':' +
              String(payload.previousQuantity || '') +
              ':' +
              String(payload.quantity || ''),
            ttlMs: 2000,
          }
        );
      }

      if (source === 'cart-addon' && mutation === 'add') {
        track(
          'cart_recommendation_add',
          {
            surface: 'cart',
            source: source,
            module: 'cart_recommendations',
            variant_id: payload.variantId || null,
          },
          {
            dedupeKey: 'cart_recommendation_add:' + String(payload.variantId || ''),
            ttlMs: 2000,
          }
        );
      }
    });
  }

  function bindCroTracking() {
    document.addEventListener('cro:impression', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (!detail.type) return;
      track(
        'cro_impression',
        {
          source: 'cro',
          surface: detail.surface || null,
          module: detail.type || null,
          experiment_variant: detail.variant || null,
        },
        {
          dedupeKey: 'cro_impression:' + [detail.type || '', detail.surface || '', detail.variant || ''].join(':'),
          ttlMs: 30000,
        }
      );
    });

    document.addEventListener('cro:interaction', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (!detail.type) return;
      track(
        'cro_interaction',
        {
          source: 'cro',
          surface: detail.surface || null,
          module: detail.type || null,
          experiment_variant: detail.variant || null,
        },
        {
          dedupeKey: 'cro_interaction:' + [detail.type || '', detail.surface || '', detail.variant || ''].join(':'),
          ttlMs: 1000,
        }
      );
    });
  }

  function bindFrictionFixTracking() {
    document.addEventListener('rr:friction-fix', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (!detail.module || !detail.action) return;

      track(
        'friction_fix_interaction',
        {
          source: 'friction_fix',
          surface: detail.surface || null,
          module: detail.module || null,
          action: detail.action || null,
          product_id: detail.productId || null,
          variant_id: detail.variantId || null,
          review_count: detail.reviewCount || null,
          rating_value: detail.ratingValue || null,
          threshold_remaining_cents: detail.thresholdRemainingCents || null,
        },
        {
          dedupeKey:
            'friction_fix:' +
            [detail.module || '', detail.surface || '', detail.action || '', detail.productId || '', detail.variantId || ''].join(':'),
          ttlMs: 500,
        }
      );

      if (detail.module === 'cart-recommendations' && detail.action === 'add') {
        track(
          'cart_recommendation_add',
          {
            source: 'friction_fix',
            surface: detail.surface || 'cart',
            module: 'cart_recommendations',
            variant_id: detail.variantId || null,
          },
          {
            dedupeKey: 'cart_recommendation_add:friction:' + String(detail.variantId || ''),
            ttlMs: 500,
          }
        );
      }
    });
  }

  function bindAovLeverTracking() {
    document.addEventListener('aov:lever', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (!detail.lever || !detail.action) return;

      var eventName = detail.action === 'impression' ? 'aov_lever_impression' : 'aov_lever_interaction';
      track(
        eventName,
        {
          source: 'aov',
          surface: detail.surface || null,
          module: detail.lever || null,
          action: detail.action || null,
          product_id: detail.product_id || null,
          value_cents: detail.value_cents || null,
        },
        {
          dedupeKey: 'aov:' + [detail.lever || '', detail.surface || '', detail.action || '', detail.product_id || ''].join(':'),
          ttlMs: detail.action === 'impression' ? 30000 : 1000,
        }
      );
    });
  }

  function detectSelectProductContext(link) {
    if (!link || !link.getAttribute) return null;

    if (link.closest('.predictive-search')) {
      return {
        eventName: 'predictive_search_click',
        surface: 'predictive_search',
        source: 'predictive_search',
      };
    }

    if (link.closest('.cart-addon-item')) {
      return {
        eventName: 'cart_recommendation_click',
        surface: 'cart',
        source: 'cart_recommendations',
      };
    }

    if (link.closest('[data-aov-lever]') || link.closest('product-recommendations')) {
      return {
        eventName: 'select_product',
        surface: 'recommendation',
        source: 'recommendation',
      };
    }

    if (page.type === 'collection' && link.closest('.card-wrapper, .grid__item, .card, .product-grid-container')) {
      return {
        eventName: 'select_product',
        surface: 'collection',
        source: 'collection_grid',
      };
    }

    if (page.type === 'search' && link.closest('.card-wrapper, .grid__item, .card')) {
      return {
        eventName: 'select_product',
        surface: 'search',
        source: 'search_results',
      };
    }

    return null;
  }

  function bindProductSelectionTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target && event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
        if (!link) return;

        var context = detectSelectProductContext(link);
        if (!context) return;

        var productHandle = resolveProductHandleFromHref(link.getAttribute('href'));
        var item = link.closest('.cart-addon-item');
        var dedupeKey = context.eventName + ':' + (productHandle || link.getAttribute('href') || '');

        track(
          context.eventName,
          {
            surface: context.surface,
            source: context.source,
            product_handle: productHandle,
            product_id: item ? item.getAttribute('data-product-id') : null,
            variant_id: item ? item.getAttribute('data-variant-id') : null,
            product_title: link.textContent || null,
            module: context.eventName === 'cart_recommendation_click' ? 'cart_recommendations' : null,
          },
          {
            dedupeKey: dedupeKey,
            ttlMs: 1000,
          }
        );
      },
      true
    );
  }

  function observeRecommendationImpressions() {
    if (typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          var entry = entries[i];
          if (!entry.isIntersecting) continue;
          var item = entry.target;
          if (recommendationImpressed.has(item)) continue;
          recommendationImpressed.add(item);
          observer.unobserve(item);

          track(
            'cart_recommendation_impression',
            {
              surface: 'cart',
              source: 'cart_recommendations',
              module: 'cart_recommendations',
              product_id: item.getAttribute('data-product-id') || null,
              variant_id: item.getAttribute('data-variant-id') || null,
            },
            {
              dedupeKey:
                'cart_recommendation_impression:' +
                String(item.getAttribute('data-product-id') || '') +
                ':' +
                String(item.getAttribute('data-variant-id') || ''),
              ttlMs: 30000,
            }
          );
        }
      },
      { threshold: 0.4 }
    );

    function observeAll() {
      var items = document.querySelectorAll('[data-rr-surface="cart-recommendations"] .cart-addon-item');
      for (var i = 0; i < items.length; i += 1) {
        if (!recommendationImpressed.has(items[i])) observer.observe(items[i]);
      }
    }

    observeAll();

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(observeAll).observe(document.body, { childList: true, subtree: true });
    }
  }

  function bindLifecycleFlushes() {
    document.addEventListener('visitorConsentCollected', function () {
      scheduleFlush(100);
    });
    document.addEventListener('trackingConsentAccepted', function () {
      scheduleFlush(100);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') scheduleFlush(100);
    });
    window.addEventListener('load', function () {
      scheduleFlush(250);
    });

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (hasRuntime() && analyticsAllowed()) {
        flushQueue();
      }
      if (tries >= 20 || hasRuntime()) {
        window.clearInterval(timer);
      }
    }, 1000);
  }

  window.RRAhrefs = {
    track: track,
    flush: flushQueue,
    trackMappedKlaviyoEvent: trackMappedKlaviyoEvent,
    analyticsAllowed: analyticsAllowed,
  };

  bindVariantTracking();
  bindCartMutationTracking();
  bindCroTracking();
  bindFrictionFixTracking();
  bindAovLeverTracking();
  bindProductSelectionTracking();
  observeRecommendationImpressions();
  bindLifecycleFlushes();
})();
